export const ROUTES = {
  HOME: '/',
  SUBMIT: '/submit-ticket',
  EVENTS: '/events',
  DIRECTORY: '/directory',
  SUPPORT_US: '/support-us',
  RESOURCES: '/resources',
}
